module.exports = __webpack_public_path__ + "static/img/yhq.034f465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yhq.png
// module id = QvK7
// module chunks = 1